export const otherDocumentsEnum = [
  { label: 'Bianko TP', value: 'BIANCO_TP' },
  { label: 'Trvale manipulační RZ', value: 'PERM_RZ' },
  { label: 'Trvale manipulační RZ s doklady', value: 'PEM_RZ_DOCS' },
  { label: 'Vývozní RZ', value: 'EXPORT_RZ' },
  { label: 'Jakýkoli', value: 'ANY' }
];

export const queryReasonsEnum = [
  { label: 'Zaevidování změny v registru', value: 'CHANGE_REGISTRY' },
  { label: 'Lustrace vozidla', value: 'CAR_LUSTRATION' },
  { label: 'Lustrace osoby', value: 'PERSON_LUSTRATION' },
  { label: 'Řešení dopravního přestupku', value: 'TRAFFIC_OFFENSE' },
  { label: 'Jiné', value: 'OTHER' }
];

export const pcrSearchResult = [
  { id: 'POZITIVNI', label: 'Pozitivní' },
  { id: 'NEGATIVNI', label: 'Negativní' },
  { id: 'ZAJMOVA', label: 'Zájmová' }
];

export const pcrVehicleSearchResult = [
  { id: 'POZITIVNI_RZ', label: 'Pozitivní RZ' },
  { id: 'POZITIVNI_VOZIDLO', label: 'Pozitivní vozidlo' },
  { id: 'POZITIVNI_R_ZI_VOZIDLO', label: 'Pozitivní RZ i vozidlo' },
  { id: 'POZITIVNI_DOKLAD', label: 'Pozitivní doklad' },
  { id: 'POZITIVNI_VOZIDLO_DOKLAD', label: 'Pozitivní vozidlo i doklad' }
];

export const pcrVehicleWarnings = [
  { id: 'RIZIKO_VYBUSNIN', label: 'Riziko výbušnin' },
  { id: 'RIZIKO_RADIACE', label: 'Riziko radiace' },
  { id: 'RIZIKO_CHEMIKALII', label: 'Riziko chemikálií' },
  { id: 'NEBEZPECNA_OSADKA', label: 'Nebezpečná posádka' },
  { id: 'PODEZRENI_NA_KLON', label: 'Podezření na klon' },
  { id: 'ZADNE', label: 'Žádné' }
];



// WEBPACK FOOTER //
// ./src/components/vehicle/_vehicleEnums.ts